<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogClave" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Change Password</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
                <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                            <v-text-field :type="show4 ? 'text' : 'password'"  v-model="modelo.contraseña" 
                            @click:append="show4 = !show4"
                            :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="ContraseñaRules" label="New password" required ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                            <v-text-field type="password" v-model="modelo.confirmacionContraseña" 
                            @click:append="show4 = !show4"
                            :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="ContraseñaRules" label="Confirm your password" required ></v-text-field>
                      </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error"  @click="cancelar" outlined>Cancel
            <v-icon right dark>cancel</v-icon>
          </v-btn>
          <v-btn color="blue darken-1"  @click="guardar" outlined>Save
            <v-icon right dark>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import HTTP from '../../services/index';
import { StringDecoder } from 'string_decoder';

  export default {
    data: () => ({
        //id:'',
        show4: false,
        modelo:{
            contraseña:'',
            confirmacionContraseña:''
        },
        valid: false,
        //dialogClave: false,
        ContraseñaRules: [
            v => !!v || 'contraseña es requerida',
            v => v.length >= 8 || 'La contraseña debe cotener al menos 8 caracteres'
        ],
    }),
    props:{
        dialogClave:Boolean,
        id:String
    },
    methods:{
        lanzar_alerta(Type,Title,Text,Footer){
        this.$swal.fire({
          type: Type,
          title: Title,
          text: Text,
          footer: Footer,
           allowOutsideClick: false
        });
      },
        claveActualizada(){
            this.modelo.contraseña=''; this.modelo.confirmacionContraseña='';
            this.lanzar_alerta('success', '¡ Good !', 'Password successfully updated');
            this.$emit('claveActualizada');
        },
        guardar(){
            var data = new FormData();
            data.append('contraseña',this.modelo.contraseña);
            data.append('confirmacionContraseña',this.modelo.confirmacionContraseña);
            data.append('id',this.id)
            HTTP.put('usuarios/updatePasswordUser',data)
            .then(response => {
                this.claveActualizada()
            }).catch(error => {
                this.lanzar_alerta('error', '¡ Opps !', 'An error occurred, check the information entered')
            });
        },
        cancelar(){
            this.$emit('cancelClave')
        }
    }
  }
</script>